import React from "react";
import { Helmet } from "react-helmet-async";
import { getPageMeta, toSeoProps } from "../seo/pageMeta";
import { getStructuredData } from "../seo/structuredData";
import { SITE_NAME, TWITTER_HANDLE } from "../seo/siteConfig";

export default function PageSEO({ pathname, course = null }) {
  const seo = toSeoProps(getPageMeta(pathname, course));
  const structuredData = getStructuredData(pathname, course);

  return (
    <Helmet>
      <html lang="en" />
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      {seo.keywords ? <meta name="keywords" content={seo.keywords} /> : null}
      <link rel="canonical" href={seo.canonical} />

      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:type" content={seo.ogType} />
      <meta property="og:url" content={seo.canonical} />
      <meta property="og:image" content={seo.ogImage} />
      <meta property="og:locale" content="en_IN" />

      {seo.articlePublishedTime ? (
        <meta property="article:published_time" content={seo.articlePublishedTime} />
      ) : null}
      {seo.articleAuthor ? (
        <meta property="article:author" content={seo.articleAuthor} />
      ) : null}
      {seo.articleSection ? (
        <meta property="article:section" content={seo.articleSection} />
      ) : null}

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content={TWITTER_HANDLE} />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:description" content={seo.description} />
      <meta name="twitter:image" content={seo.ogImage} />

      {seo.noindex ? <meta name="robots" content="noindex, follow" /> : <meta name="robots" content="index, follow" />}

      {structuredData.map((schema, index) => (
        <script key={`schema-${index}`} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
}
